import React from "react";
import KPRKalkulator from "../app/ui/KPRKalkulator/KPRKalkulator";

const Main = React.lazy(() => import('../app/ui/Main'))
const ListingList = React.lazy(() => import('../app/ui/listing/ListingList'))
const ListingDetail = React.lazy(() => import('../app/ui/listing/ListingDetail'))
const AgentList = React.lazy(() => import('../app/ui/agents/AgentList'))
const AgentDetail = React.lazy(() => import('../app/ui/agents/AgentDetail'))
const AboutUs = React.lazy(() => import('../app/ui/about-us/AboutUs'))

const routes = [
    {
        name: "Home",
        route: "/",
        component: <Main />,
    },
    {
        name: "Rumah Second",
        route: "/listing",
        component: <ListingList />,
    },
    // {
    //     name: "Rumah Baru",
    //     route: "/proyek",
    //     component: <ListingList />,
    // },
    {
        name: "Detail",
        route: "/listing/:id",
        component: <ListingDetail />,
    },
    {
        name: "Share",
        route: "/listing/:share/:id",
        component: <ListingDetail />,
    },
    {
        name: "Agent",
        route: "/agents",
        component: <AgentList />,
    },
    {
        name: "Agent",
        route: "/agents/:id",
        component: <AgentDetail />,
    },
    {
        name: "About Us",
        route: "/about-us",
        component: <AboutUs />,
    },
    {
        name: "Kalkulator KPR",
        route: "/kalkulator-kpr",
        component: <KPRKalkulator />,
    },
]
export default routes